// Frontend mirror of the SPORTS constant in /app/backend/server.py.
// Kept in sync manually — the /api/sports endpoint is the source of truth,
// this file is used only for form dropdowns before the network fetch settles.
export const SPORTS = [
  "Football (Soccer)", "Cricket", "Badminton", "Volleyball", "Basketball",
  "Athletics (Track & Field)", "Running", "Marathon", "Sprinting",
  "Tennis", "Table Tennis", "Pickleball", "Padel", "Squash",
  "Swimming", "Cycling", "Triathlon", "Gymnastics",
  "CrossFit", "Functional Fitness", "Bodybuilding", "Powerlifting", "Olympic Weightlifting",
  "Wrestling", "Boxing", "Kickboxing", "Muay Thai", "MMA", "Brazilian Jiu-Jitsu",
  "Judo", "Karate", "Taekwondo", "Fencing",
  "Hockey", "Rugby", "Baseball", "Softball",
  "Golf", "Archery", "Shooting", "Rowing", "Canoeing", "Kayaking",
  "Surfing", "Skating", "Skateboarding", "Climbing",
  "Ultimate Frisbee", "Kabaddi", "Chess", "Other",
];

export const ATHLETE_CLASSES = [
  { value: "regular", label: "REGULAR ATHLETE" },
  { value: "pro",     label: "PRO ATHLETE" },
];
